import { render, staticRenderFns } from "./rolePublic.vue?vue&type=template&id=4f8bff0d&scoped=true&"
import script from "./rolePublic.vue?vue&type=script&lang=js&"
export * from "./rolePublic.vue?vue&type=script&lang=js&"
import style0 from "./rolePublic.vue?vue&type=style&index=0&id=4f8bff0d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8bff0d",
  null
  
)

export default component.exports